export default __webpack_public_path__ + "static/media/footer.f9815319.svg";